import { lazy, Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";

import Dropdowns from "./component/Dropdowns";
import PageLoader from "./component/PageLoader";
import ProtectedRoute from "./component/ProtectedRoute";
import GlobalRippleEffect from "./hooks/rippleEffect";
// 🔹 Lazy Loaded Pages
const Loginpage = lazy(() => import("./component/Loginpage"));
const Home = lazy(() => import("./component/Home"));
const Departments = lazy(() => import("./component/Departments"));
const Thesis_publications = lazy(() => import("./component/Thesis_publications"));
const Appraisals = lazy(() => import("./component/Appraisals"));
const Aetcom_skills = lazy(() => import("./component/Aetcom_skills"));
const Reports = lazy(() => import("./component/Reports"));
const Alerts = lazy(() => import("./component/Alerts"));
const Settings = lazy(() => import("./component/Settings"));
const Skills_procedure = lazy(() => import("./component/Skills_procedure"));

const RolePermissionList = lazy(() => import("./component/RolePermissionList"));
const PermissionListGiven = lazy(() => import("./component/PermissionListGiven"));
const Roles = lazy(() => import("./component/Roles"));
const Permission = lazy(() => import("./component/Permission"));
const Users = lazy(() => import("./component/Users"));
const Adduser = lazy(() => import("./component/Adduser"));

const Allstudent = lazy(() => import("./component/Allstudent"));
const Allstaff = lazy(() => import("./component/Allstaff"));
const Staffview = lazy(() => import("./component/Staffview"));
const Studentview = lazy(() => import("./component/Studentview"));
const Profile = lazy(() => import("./component/Profile"));
const Institutes = lazy(() => import("./component/Institutes"));
const AffiliateUser = lazy(() => import("./component/AffiliateUser"));
const NotFound = lazy(() => import("./component/NotFound"));

function App() {
  return (
    <>
      <GlobalRippleEffect />

      {/* 🔥 Suspense Loader */}
      <Suspense fallback={<PageLoader />}>
    <GlobalRippleEffect />
    <Routes>
      <Route path="/" element={<Loginpage />} />
      <Route path="/affiliate" element={<AffiliateUser />} />
      <Route path="/dashboard" element={ <ProtectedRoute><Home /> </ProtectedRoute>} />
      <Route path="/departments" element={ <ProtectedRoute><Departments /> </ProtectedRoute>} />
      <Route path="/thesis" element={ <ProtectedRoute><Thesis_publications /> </ProtectedRoute>} />
      <Route path="/appraisal" element={ <ProtectedRoute><Appraisals /> </ProtectedRoute>} />
      <Route path="/aetcom" element={ <ProtectedRoute><Aetcom_skills /> </ProtectedRoute>} />
      <Route path="/reports" element={ <ProtectedRoute><Reports /> </ProtectedRoute>} />
      <Route path="/alerts" element={ <ProtectedRoute><Alerts /> </ProtectedRoute>} />
      <Route path="/settings" element={ <ProtectedRoute><Settings /> </ProtectedRoute>} />
      <Route path="/skill" element={ <ProtectedRoute><Skills_procedure /> </ProtectedRoute>} />
      
      <Route path="/roles" element={ <ProtectedRoute><RolePermissionList /> </ProtectedRoute>} />
      <Route path="/permissions" element={ <ProtectedRoute><PermissionListGiven /> </ProtectedRoute>} />
      <Route path="/users" element={ <ProtectedRoute><Users /> </ProtectedRoute>} />
      <Route path="/users/roles" element={ <ProtectedRoute><Roles /> </ProtectedRoute>} />
      <Route path="/users/permission" element={ <ProtectedRoute><Permission /> </ProtectedRoute>} />
      <Route path="/users/adduser" element={ <ProtectedRoute><Adduser /> </ProtectedRoute>} />
      <Route path="/student" element={ <ProtectedRoute><Allstudent /> </ProtectedRoute>} />
      <Route path="/staff" element={ <ProtectedRoute><Allstaff /> </ProtectedRoute>} />
      <Route path="/staff/:type/:id" element={ <ProtectedRoute><Staffview /> </ProtectedRoute>} />
      <Route path="/profile" element={ <ProtectedRoute><Profile /> </ProtectedRoute>} />
      <Route path="/student/view/:id" element={ <ProtectedRoute><Studentview /> </ProtectedRoute>} />
      <Route path="/institute/list" element={ <ProtectedRoute><Institutes /> </ProtectedRoute>} />

      <Route path="/setup" element={ <ProtectedRoute><Dropdowns /> </ProtectedRoute>} />
      <Route path="/control" element={ <ProtectedRoute><Dropdowns /> </ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </Suspense>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
}

export default App;
